{
  "pt": {
    "pagination": {
      "previous": "Página anterior",
      "next": "Próxima página",
      "page_report": "Página {page} de {total}",
      "report": "Mostrando {first} a {last} de {total}",
      "total": "Total de itens: {total}"
    }
  }
}